import React from 'react';
import './loading-spinner.scss';

const LoadingSpiner = () => {
    return (
        <div className='loading-spinner'></div>
    )
}

export default LoadingSpiner;